import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import { Menu, X } from 'lucide-react';
import { Sidebar } from '@/components/Sidebar';

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-dvh overflow-hidden surface-page">
      {/* Desktop sidebar: always present, part of the layout flow. */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Mobile sidebar: an overlay drawer, so it can't squeeze the content. */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 flex md:hidden">
          <button
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileOpen(false)}
            aria-label="Navigation schließen"
          />
          <div className="relative z-10">
            <Sidebar onClose={() => setMobileOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <button
          className="flex h-12 w-full items-center gap-2 border-b line surface-card px-4
                     text-sm font-medium text-strong md:hidden"
          onClick={() => setMobileOpen((v) => !v)}
        >
          {mobileOpen ? <X className="size-4" /> : <Menu className="size-4" />}
          Ecotone Tasks
        </button>

        <main className="min-h-0 flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
